import { useCallback, useEffect, useState } from "react";
import Loader from "../../common/Loader";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Divider,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  Modal,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  Alert
} from "@mui/material";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_EXPENSES } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import moment from "moment";
import PictureViewer from "../common/PictureViewer";
import { English } from "../../constant/EnglishFallback";
import InfoIcon from "@mui/icons-material/Info";

const ViewExpenses = ({
  openModal,
  expensesDataId,
  closeModal,
  setShowAddExpensesModal,
  setSelectedExpense,
  saveExpensesFlag,
  fetchExpensesData
}) => {
  const [loadingViewModel, setLoadingViewModel] = useState(false);
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const [expenseData, setExpenseData] = useState([]);
  const [imageIndex, setImageIndex] = useState(null);
  const [pictureViewer, setPictureViewer] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const LanguageData = multiLanguageData?.Expenses || {};
  const {
    TEXT_DATE = English.Expenses.TEXT_DATE,
    TEXT_TOTAL_AMOUNT = English.Expenses.TEXT_TOTAL_AMOUNT,
    TEXT_PROJECT = English.Expenses.TEXT_PROJECT,
    TEXT_DESCRIPTION = English.Expenses.TEXT_DESCRIPTION,
    TEXT_COMMENTS = English.Expenses.TEXT_COMMENTS,
    TEXT_EXPENSE_HAS_SENT = English.Expenses.TEXT_EXPENSE_HAS_SENT,
    TEXT_VIEW_EXPENSES = English.Expenses.TEXT_VIEW_EXPENSES,
    TEXT_LAST_MODIFIED = English.Expenses.TEXT_LAST_MODIFIED
  } = LanguageData || {};

  const handleEditClick = (item) => {
    setSelectedExpense(item);
    setShowAddExpensesModal(true);
  };

  const fetchExpenses = useCallback(async () => {
    setLoadingViewModel(true);
    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 10,
        FullSearch: "",
        UserId: Number(loginData?.userInformation?.UserId),
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        SearchList: [
          {
            UserId: Number(loginData?.userInformation?.UserId),
            id: expensesDataId?.id
          }
        ],
        SortList: [
          {
            FieldName: "Id",
            Direction: "DESC"
          }
        ]
      };

      const fetchExpensesRes = await Postrequestcall(FETCH_EXPENSES, obj, loginData?.accessToken);
      setExpenseData(fetchExpensesRes?.data?.data[0]);
      setLoadingViewModel(false);
    } catch (error) {
      console.log("fetchExpenses-> Error fetching Expenses: ", error);
    } finally {
      setLoadingViewModel(false);
    }
  }, []);

  useEffect(() => {
    fetchExpenses();
  }, [expensesDataId]);

  const handlecloseModal = () => {
    setExpenseData([]);
    closeModal();
    if (saveExpensesFlag) {
      fetchExpensesData(1);
    }
  };

  return (
    <Modal open={openModal}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6">{TEXT_VIEW_EXPENSES}</Typography>
          <Stack direction={"row"}>
            <IconButton
              color="primary"
              onClick={() => {
                handleEditClick(expenseData);
                // closeModal();
              }}>
              <EditIcon />
            </IconButton>
            <IconButton onClick={handlecloseModal}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>
        {loadingViewModel ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "450px"
            }}>
            <Loader />
          </Box>
        ) : (
          <Box maxHeight={"500px"} overflow={"scroll"} sx={{ scrollbarWidth: "none" }}>
            <Stack direction={"column"} spacing={1.5}>
              {Array.isArray(expenseData?.pictureList) && expenseData.pictureList.length > 0 && (
                <Stack>
                  <Grid
                    size={{ xs: 12, sm: 12, md: 12 }}
                    sx={{ height: isSmallScreen ? 90 : 130 }}>
                    <ImageList
                      gap={7.5}
                      sx={{
                        width: "100%",
                        height: "100%",
                        margin: 0,
                        padding: 0,
                        flexWrap: "nowrap",
                        overflowX: "auto",
                        display: "flex",
                        pb: 0.5,
                        cursor: "pointer",
                        borderRadius: "10px",
                        backgroundColor: "white"
                      }}>
                      {expenseData.pictureList.map((picItem, picIndex) => (
                        <ImageListItem key={picIndex} sx={{ minWidth: isSmallScreen ? 90 : 130 }}>
                          <img
                            src={
                              picItem?.pictureUrl
                                ? picItem?.pictureUrl
                                : URL.createObjectURL(picItem)
                            }
                            style={{
                              borderRadius: 10,
                              width: isSmallScreen ? 90 : 130,
                              height: isSmallScreen ? 90 : 130,
                              objectFit: "cover"
                            }}
                            alt="Expenses"
                            loading="lazy"
                            onClick={() => {
                              setImageIndex(picIndex);
                              setPictureViewer(true);
                            }}
                          />
                        </ImageListItem>
                      ))}
                    </ImageList>
                  </Grid>
                </Stack>
              )}

              <Divider />
              <Stack direction={"row"} sx={{ width: "100%" }} spacing={2}>
                <Stack sx={{ flex: 1 }}>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {TEXT_DATE}
                  </Typography>
                  <Typography variant="body1">
                    {moment(expenseData.expenseDate).format("MMMM DD, YYYY")}
                  </Typography>
                </Stack>
                <Stack sx={{ flex: 1 }}>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {TEXT_TOTAL_AMOUNT}
                  </Typography>
                  <Typography variant="body1">
                    {`${expenseData?.totalAmount?.toFixed(2)}`}
                  </Typography>
                </Stack>
              </Stack>
              <Stack>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {TEXT_DESCRIPTION}
                </Typography>
                <Typography variant="body1"> {expenseData.description} </Typography>
              </Stack>
              <Stack>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {TEXT_PROJECT}
                </Typography>
                <Typography variant="body1"> {expenseData.projectName} </Typography>
              </Stack>
              <Stack>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {TEXT_COMMENTS}
                </Typography>
                <Typography variant="body1"> {expenseData.comments} </Typography>
              </Stack>

              {expenseData?.isSent && (
                <Grid size={12}>
                  <Alert icon={<InfoIcon />} severity="warning">
                    {TEXT_EXPENSE_HAS_SENT}
                  </Alert>
                </Grid>
              )}

              <Divider />
              <Stack sx={{ alignItems: "flex-end" }}>
                <Typography sx={{ color: "text.secondary" }}>
                  {TEXT_LAST_MODIFIED}{" "}
                  {moment.parseZone(expenseData?.dateModified).local().format("YYYY-DD-MM h:mm a")}
                </Typography>
              </Stack>
            </Stack>
          </Box>
        )}

        {pictureViewer && expenseData.pictureList && (
          <PictureViewer
            isOpen={pictureViewer}
            onClose={() => setPictureViewer(false)}
            pictures={expenseData.pictureList?.map((item, i) => {
              return { src: item?.pictureUrl || URL.createObjectURL(item) };
            })}
            viewerIndex={imageIndex}
          />
        )}
      </Box>
    </Modal>
  );
};

export default ViewExpenses;
